import { setHideFiltered } from '../../search-and-filter-schema/protected';
const updateFilteredToggle = (filters, filterValue) => {
  return setHideFiltered(filterValue, filters);
};
export default updateFilteredToggle;